// extracted by mini-css-extract-plugin
export default {"container":"VF-z","header":"WF-z","details":"XF-z","link":"YF-z"};